module.exports = __webpack_public_path__ + "static/media/man.d513f027.png";